import axios from "axios";
import Store from "../store";
import { LOGOUT } from "../store/Types/AuthTypes";
import { BASE_URL } from "../config/apiConfig";
import { toast } from "react-toastify";

const backendValidUser = axios.create({
  baseURL: BASE_URL,
});

backendValidUser.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("myToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

backendValidUser.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      // Sirf unauthorized pe logout — upload errors 401 nahi hote
      localStorage.clear();
      Store.dispatch({ type: LOGOUT });
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    } else if (!error.response) {
      // Network error — server down ya internet nahi
      toast.error("Network error. Please check your connection.");
    } else if (status === 400) {
      // Bad request — validation ya file upload error, logout nahi
      const msg = error.response?.data?.error?.msg || "Invalid request. Please check your inputs.";
      toast.error(msg);
    } else if (status === 413) {
      // Nginx/proxy level file size limit
      toast.error("File is too large. Please upload a smaller image.");
    } else if (status === 422) {
      toast.error("Invalid data submitted. Please check your inputs.");
    } else if (status >= 500) {
      // Server error — user ko batao, logout nahi
      const msg = error.response?.data?.error?.msg || "Server error occurred. Please try again.";
      toast.error(msg);
    }

    return Promise.reject(error);
  }
);

export default backendValidUser;
